import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogContent, DialogTitle,
} from '@material-ui/core';

const SwitchSourceModal = ({
  open, sources, onClose, onSwtich, title,
}) => {
  const [value, setValue] = useState('');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="dialog-sm"
      aria-labelledby="preview-modal-title"
    >
      <DialogTitle id="preview-modal-title">
        { title }
      </DialogTitle>
      <DialogContent className="preview-item-container" id="preview-modal-dialog">
        <div className="text-center" style={{ marginBottom: 10 }}>
          <select
            style={{ marginBottom: '24px' }}
            className="form-control"
            id="source_list"
            value={value}
            onChange={e => setValue(e.target.value)}
          >
            <option key="default" value="">Please Select</option>
            { sources.map(s => (
              <option key={s[0]} value={s[0]}>
                {s[1]}
                {' '}
                [id:
                {' '}
                { s[0] }
                ]
              </option>
            )) }
          </select>
          <button className="btn bg-olive" onClick={() => (value ? onSwtich(value) : onClose())}>Update</button>
          <button className="btn btn-primary" style={{ marginLeft: '5px' }} onClick={onClose}>Cancel</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

SwitchSourceModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSwtich: PropTypes.func.isRequired,
  sources: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.oneOfType(
        [PropTypes.number, PropTypes.string],
      ),
    ),
  ).isRequired, // [id, label][]
  title: PropTypes.string,
};

SwitchSourceModal.defaultProps = {
  title: 'Choose another source',
};

export default SwitchSourceModal;
